import { Routes } from '@/router/routes'

import { AppPermissions } from '@/types/enums/permissions/permissions'
import { Middleware } from '@/types/enums/middleware/middleware'

export const customEventsRoutes = [
  {
    path: '/custom-events',
    name: Routes.CustomEventIndex,
    component: () => import('@/pages/contexts/portal/custom-events/Index.vue'),
    meta: {
      pageTitle: 'Manage Custom Events',
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
      ],
      permission: AppPermissions.MANAGE_CUSTOM_EVENTS,
    },
    children: [
      {
        path: 'create-custom-event',
        name: Routes.CustomEventCreate,
        component: () => import('@/pages/contexts/portal/custom-events/Create.vue'),
        meta: {
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.MANAGE_CUSTOM_EVENTS,
        },
      },
      {
        path: 'update-custom-event/:customEventId',
        name: Routes.CustomEventUpdate,
        component: () => import('@/pages/contexts/portal/custom-events/Update.vue'),
        meta: {
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.MANAGE_CUSTOM_EVENTS,
        },
      },
    ],
  },
]
